import sendData from '../../utilities/xhr';

export function quantityControls(selector: string, callBack?: (target: Element, count: string) => any) {

    const getUrl = window.location;
    const baseUrl = getUrl .protocol + '//' + getUrl.host + '/' + getUrl.pathname.split('/')[0];
    let timer: number;
    const checkout = document.querySelector(selector);
    if(checkout) {
        checkout.addEventListener('click', (e: any) => {
            if (e.target.matches('.incrementer')) {
                const quantityField: HTMLDivElement = e.target.parentElement;
                const input: HTMLInputElement = quantityField.querySelector('.pos-item-quantity');
                const cartItemId = input.getAttribute('data-cart-item-id');
                const currentValue = input.value;
                let newVal: string;
                if (e.target.classList.contains('incrementer-inc')) {
                    if (parseInt(currentValue) < parseInt(input.max)) {
                        newVal = (parseInt(currentValue) + 1).toString();
                        input.value = newVal;
                        !quantityField.className.includes('no-item') && cartRefresh(cartItemId, newVal);
                        if (callBack) callBack(e.target, newVal);
                    }
                } else {
                    if (input.value !== '1') {
                        newVal = (parseInt(currentValue) - 1).toString();
                        input.value = newVal;
                        !quantityField.className.includes('no-item') && cartRefresh(cartItemId, newVal);
                        if (callBack) callBack(e.target, newVal);
                    }
                }
            }
        });
    }

    function cartRefresh(cartItemId: string, quantity: string) {
        clearTimeout(timer);
        timer = window.setTimeout(() => {
            sendData(baseUrl + 'order/cart/item/' + cartItemId + '/quantity', {quantity: quantity}, true);
        }, 1000);
    }

    const quantityFields = document.querySelectorAll('.divTableBody .pos-item-quantity');

    quantityFields.forEach((field: HTMLInputElement) => {
        field.addEventListener('change', (e) => {
            const cartItemId = field.getAttribute('data-cart-item-id');
            const quantity = field.value;
            sendData(baseUrl + 'order/cart/item/' + cartItemId + '/quantity', {quantity: quantity}, true);
            e.preventDefault()
        });
        field.addEventListener('keydown', (e) => {
            if (e.which === 13) {
                const cartItemId = field.getAttribute('data-cart-item-id');
                const quantity = Math.floor(parseInt(field.value));
                sendData(baseUrl + 'order/cart/item/' + cartItemId + '/quantity', {quantity: quantity}, true);
                e.preventDefault();
            }
        });
    });
}
